export const loadingStatuses = {
  STATUS_LOADING: 1,
  STATUS_LOADED: 2,
};
